// This file was automatically generated from Intercom.BotDirectory.dll. Do not edit directly!

    /** Optionally, set this variable to your network activity indicator function. */
    export var showNetworkIcon = (show: boolean) => { };

    /** Optionally, set this to your own ajax function. */
    export var ajax: (settings: JQueryAjaxSettings) => JQueryPromise<any> = _ajax;

    /** Optionally, set this to a string that all urls should be prefixed with. */
    export var urlPrefix = '';

    /** Optionally, set this to additional header key/value pairs to send along with ajax requests. */
    export var ajaxHeaders: { [key: string]: any } = null;

    /** Wraps jQuery's ajax function and adds network activity indicator. */
    function _ajax(settings_: JQueryAjaxSettings): JQueryPromise<any> {
        var settings: JQueryAjaxSettings = $.extend({}, settings_, { url: urlPrefix + settings_.url });
        if (settings.data)
            settings.contentType = 'application/json';
        if (ajaxHeaders)
            settings.headers = ajaxHeaders;
        showNetworkIcon(true);
        return $.ajax(settings).always(() => showNetworkIcon(false));
    }

    /** Corresponds to Intercom.BotDirectory.Server.Controllers.BotsController */
    export class BotsClient {
        /** Corresponds to GetBotContactCard(string botId, string t) */
        public static getBotContactCard(botId: string, t: string): JQueryPromise<BotContactCard> {
            return ajax({
                dataType: 'json',
                url: `/api/bots/${botId}` + '?' + $.param({ t: t }),
                type: 'GET',
            });
        }
    }

    /** Corresponds to Intercom.BotDirectory.Server.Controllers.BotDirectoryController */
    export class BotDirectoryClient {
        /** Corresponds to GetBots(string searchString, int pageSize, int page, SortOrder sort) */
        public static getBots(searchString: string, pageSize: number, page: number, sort: SortOrder): JQueryPromise<BotsResult> {
            return ajax({
                dataType: 'json',
                url: '/api/BotDirectory' + '?' + $.param({ searchString: searchString, pageSize: pageSize, page: page, sort: sort }),
                type: 'GET',
            });
        }

        /** Corresponds to FeaturedBots(int pageSize, int page, SortOrder sort) */
        public static featuredBots(pageSize: number, page: number, sort: SortOrder): JQueryPromise<BotsResult> {
            return ajax({
                dataType: 'json',
                url: '/api/BotDirectory/Featured' + '?' + $.param({ pageSize: pageSize, page: page, sort: sort }),
                type: 'GET',
            });
        }

        /** Corresponds to GetBot(string id, string token) */
        public static getBot(id: string, token: string): JQueryPromise<BotViewModel> {
            return ajax({
                dataType: 'json',
                url: '/api/BotDirectory/GetBot' + '?' + $.param({ id: id, token: token }),
                type: 'GET',
            });
        }

        /** Corresponds to IBot() */
        public static iBot(): JQueryPromise<IBot> {
            return ajax({
                dataType: 'json',
                url: '/api/BotDirectory',
                type: 'GET',
            });
        }

        /** Corresponds to GetChannels() */
        public static getChannels(): JQueryPromise<Channel[]> {
            return ajax({
                dataType: 'json',
                url: '/api/BotDirectory/GetChannels',
                type: 'GET',
            });
        }

        /** Corresponds to GetBotVCard(string botId) */
        public static getBotVCard(botId: string): JQueryPromise<any> {
            return ajax({
                url: `/api/BotDirectory/${botId}`,
                type: 'GET',
            });
        }
    }

    /** Corresponds to Intercom.BotDirectory.Server.Controllers.RssController */
    export class RssClient {
        /** Corresponds to GetAll() */
        public static getAll(): JQueryPromise<BotViewModel[]> {
            return ajax({
                dataType: 'json',
                url: '/api/Rss',
                type: 'GET',
            });
        }
    }

    /** Corresponds to Intercom.BotDirectory.Server.Controllers.Models.BotContactCard, optional properties */
    export interface _BotContactCard {
        Id?: string;
        Name?: string;
        CreatedDate?: DateTimeOffset;
        Languages?: string[];
        Hashtags?: string[];
        Publisher?: string;
        PublisherEmail?: string;
        Website?: string;
        IconUrl?: string;
        Description?: string;
        Contacts?: ContactCard[];
        DeveloperBotTermsOfUseUrl?: string;
        ChannelName?: string;
        ChannelIconUrl?: string;
        VCardUrl?: string;
    }

    /** Corresponds to Intercom.BotDirectory.Server.Controllers.Models.BotContactCard */
    export interface BotContactCard {
        Id: string;
        Name: string;
        CreatedDate: DateTimeOffset;
        Languages: string[];
        Hashtags: string[];
        Publisher: string;
        PublisherEmail: string;
        Website: string;
        IconUrl: string;
        Description: string;
        Contacts: ContactCard[];
        DeveloperBotTermsOfUseUrl: string;
        ChannelName: string;
        ChannelIconUrl: string;
        VCardUrl: string;
    }

    /** Corresponds to Intercom.BotDirectory.Server.Controllers.Models.BotsResult */
    export interface BotsResult {
        TotalCount: number;
        Items: BotDocument[];
        Sort: SortOrder;
    }

    /** Corresponds to Intercom.Models.Search.SortOrder */
    export enum SortOrder {
        ByName = 0, 
        ByDate = 1, 
        ByRelevance = 2, 
        ByDisplayOrder = 3, 
        ByActivityRank = 4, 
        ByDateAsc = 5
    }

    /** Corresponds to Intercom.BotDirectory.Server.Controllers.Models.BotViewModel, optional properties */
    export interface _BotViewModel {
        Id?: string;
        Name?: string;
        Contacts?: ContactInfo[];
        Languages?: string[];
        OwnerIds?: string[];
        Hashtags?: string[];
        Publisher?: string;
        PublisherEmail?: string;
        Website?: string;
        IconUrl?: string;
        Options?: BotOptions;
        Description?: string;
        EnabledChannels?: string[];
        ListedChannels?: string[];
        Listed?: boolean;
        ApprovedForBotDirectory?: boolean;
        EnableWebChatInDirectory?: boolean;
        DefaultIconColorHash?: string;
        ChannelStatus?: ChannelStatus[];
        WebChatToken?: string;
        CreatedDate?: DateTimeOffset;
        LastSavedDate?: DateTimeOffset;
        DeveloperBotPrivacyUrl?: string;
        DeveloperBotTermsOfUseUrl?: string;
        FeaturedDisplayOrder?: number;
    }

    /** Corresponds to Intercom.BotDirectory.Server.Controllers.Models.BotViewModel */
    export interface BotViewModel {
        Id: string;
        Name: string;
        Contacts: ContactInfo[];
        Languages: string[];
        OwnerIds: string[];
        Hashtags: string[];
        Publisher: string;
        PublisherEmail: string;
        Website: string;
        IconUrl: string;
        Options: BotOptions;
        Description: string;
        EnabledChannels: string[];
        ListedChannels: string[];
        Listed: boolean;
        ApprovedForBotDirectory: boolean;
        EnableWebChatInDirectory: boolean;
        DefaultIconColorHash: string;
        ChannelStatus: ChannelStatus[];
        WebChatToken: string;
        CreatedDate: DateTimeOffset;
        LastSavedDate: DateTimeOffset;
        DeveloperBotPrivacyUrl: string;
        DeveloperBotTermsOfUseUrl: string;
        FeaturedDisplayOrder: number;
    }

    /** Corresponds to Intercom.Models.IBot, optional properties */
    export interface _IBot {
        Id?: string;
        Name?: string;
        Languages?: string[];
        OwnerIds?: string[];
        Hashtags?: string[];
        Publisher?: string;
        PublisherEmail?: string;
        IconUrl?: string;
        Description?: string;
        EnabledChannels?: string[];
        ListedChannels?: string[];
        Listed?: boolean;
        ApprovedForBotDirectory?: boolean;
        DefaultIconColorHash?: string;
    }

    /** Corresponds to Intercom.Models.IBot */
    export interface IBot {
        Id: string;
        Name: string;
        Languages: string[];
        OwnerIds: string[];
        Hashtags: string[];
        Publisher: string;
        PublisherEmail: string;
        IconUrl: string;
        Description: string;
        EnabledChannels: string[];
        ListedChannels: string[];
        Listed: boolean;
        ApprovedForBotDirectory: boolean;
        DefaultIconColorHash: string;
    }

    /** Corresponds to Intercom.Models.Channel, optional properties */
    export interface _Channel extends _ETagObject {
        Id?: string;
        Name?: string;
        Description?: string;
        Endpoint?: string;
        UserConfigurationUrl?: string;
        DeveloperConfigurationUrl?: string;
        DeveloperConfigLogoutUrl?: string;
        IconUrl?: string;
        Options?: ChannelOptions;
        UserConfigurationTemplate?: string;
        SystemStatus?: string;
    }

    /** Corresponds to Intercom.Models.Channel */
    export interface Channel extends ETagObject {
        Id: string;
        Name: string;
        Description: string;
        Endpoint: string;
        UserConfigurationUrl: string;
        DeveloperConfigurationUrl: string;
        DeveloperConfigLogoutUrl: string;
        IconUrl: string;
        Options: ChannelOptions;
        UserConfigurationTemplate: string;
        SystemStatus: string;
    }

    /** Corresponds to System.DateTimeOffset, optional properties */
    export interface _DateTimeOffset {
        DateTime?: Date;
        UtcDateTime?: Date;
        LocalDateTime?: Date;
        Date?: Date;
        Day?: number;
        DayOfWeek?: DayOfWeek;
        DayOfYear?: number;
        Hour?: number;
        Millisecond?: number;
        Minute?: number;
        Month?: number;
        Offset?: TimeSpan;
        Second?: number;
        Ticks?: number;
        UtcTicks?: number;
        TimeOfDay?: TimeSpan;
        Year?: number;
    }

    /** Corresponds to System.DateTimeOffset */
    export interface DateTimeOffset {
        DateTime: Date;
        UtcDateTime: Date;
        LocalDateTime: Date;
        Date: Date;
        Day: number;
        DayOfWeek: DayOfWeek;
        DayOfYear: number;
        Hour: number;
        Millisecond: number;
        Minute: number;
        Month: number;
        Offset: TimeSpan;
        Second: number;
        Ticks: number;
        UtcTicks: number;
        TimeOfDay: TimeSpan;
        Year: number;
    }

    /** Corresponds to Intercom.BotDirectory.Server.Controllers.Models.ContactCard, optional properties */
    export interface _ContactCard {
        ChannelId?: string;
        ContactType?: string;
        ChannelName?: string;
        ChannelIconUrl?: string;
        Name?: string;
        Address?: string;
        HtmlLink?: string;
    }

    /** Corresponds to Intercom.BotDirectory.Server.Controllers.Models.ContactCard */
    export interface ContactCard {
        ChannelId: string;
        ContactType: string;
        ChannelName: string;
        ChannelIconUrl: string;
        Name: string;
        Address: string;
        HtmlLink: string;
    }

    /** Corresponds to Intercom.Models.Search.BotDocument, optional properties */
    export interface _BotDocument {
        Id?: string;
        EntityKey?: string;
        Name?: string;
        Description?: string;
        OwnerIds?: string[];
        Hashtags?: string[];
        Publisher?: string;
        PublisherEmail?: string;
        Languages?: string[];
        IconUrl?: string;
        DefaultIconColorHash?: string;
        EnabledChannels?: string[];
        ListedChannels?: string[];
        Listed?: boolean;
        ApprovedForBotDirectory?: boolean;
        Submitted?: boolean;
        SystemHashtags?: string[];
        ChannelAddresses?: string[];
        SortName?: string;
        CreatedDate?: DateTimeOffset;
        LastSavedDate?: DateTimeOffset;
        FeaturedDisplayOrder?: number;
        ActivityRank?: number;
    }

    /** Corresponds to Intercom.Models.Search.BotDocument */
    export interface BotDocument {
        Id: string;
        EntityKey: string;
        Name: string;
        Description: string;
        OwnerIds: string[];
        Hashtags: string[];
        Publisher: string;
        PublisherEmail: string;
        Languages: string[];
        IconUrl: string;
        DefaultIconColorHash: string;
        EnabledChannels: string[];
        ListedChannels: string[];
        Listed: boolean;
        ApprovedForBotDirectory: boolean;
        Submitted: boolean;
        SystemHashtags: string[];
        ChannelAddresses: string[];
        SortName: string;
        CreatedDate: DateTimeOffset;
        LastSavedDate: DateTimeOffset;
        FeaturedDisplayOrder: number;
        ActivityRank: number;
    }

    /** Corresponds to Intercom.Models.ContactInfo, optional properties */
    export interface _ContactInfo {
        ChannelId?: string;
        Address?: string;
        ContactType?: ContactType;
        Name?: string;
        HtmlLink?: string;
    }

    /** Corresponds to Intercom.Models.ContactInfo */
    export interface ContactInfo {
        ChannelId: string;
        Address: string;
        ContactType: ContactType;
        Name: string;
        HtmlLink: string;
    }

    /** Corresponds to Intercom.Models.BotOptions */
    export enum BotOptions {
        None = 0, 
        AllMessages = 2, 
        AutoTranslate = 4, 
        DisableLogging = 8, 
        DisableMentionStripping = 16
    }

    /** Corresponds to Intercom.Models.ChannelStatus, optional properties */
    export interface _ChannelStatus {
        ChannelId?: string;
        Status?: ChannelStatusType;
        Message?: string;
    }

    /** Corresponds to Intercom.Models.ChannelStatus */
    export interface ChannelStatus {
        ChannelId: string;
        Status: ChannelStatusType;
        Message: string;
    }

    /** Corresponds to Intercom.Azure.Helpers.ETagObject, optional properties */
    export interface _ETagObject {
        ETag?: string;
    }

    /** Corresponds to Intercom.Azure.Helpers.ETagObject */
    export interface ETagObject {
        ETag: string;
    }

    /** Corresponds to Intercom.Models.ChannelOptions */
    export enum ChannelOptions {
        None = 0, 
        DisableLogging = 1, 
        Hidden = 2, 
        NotListable = 4
    }

    /** Corresponds to System.DayOfWeek */
    export enum DayOfWeek {
        Sunday = 0, 
        Monday = 1, 
        Tuesday = 2, 
        Wednesday = 3, 
        Thursday = 4, 
        Friday = 5, 
        Saturday = 6
    }

    /** Corresponds to System.TimeSpan, optional properties */
    export interface _TimeSpan {
        Ticks?: number;
        Days?: number;
        Hours?: number;
        Milliseconds?: number;
        Minutes?: number;
        Seconds?: number;
        TotalDays?: number;
        TotalHours?: number;
        TotalMilliseconds?: number;
        TotalMinutes?: number;
        TotalSeconds?: number;
    }

    /** Corresponds to System.TimeSpan */
    export interface TimeSpan {
        Ticks: number;
        Days: number;
        Hours: number;
        Milliseconds: number;
        Minutes: number;
        Seconds: number;
        TotalDays: number;
        TotalHours: number;
        TotalMilliseconds: number;
        TotalMinutes: number;
        TotalSeconds: number;
    }

    /** Corresponds to Intercom.Models.Search.IDocument, optional properties */
    export interface _IDocument {
        Id?: string;
    }

    /** Corresponds to Intercom.Models.Search.IDocument */
    export interface IDocument {
        Id: string;
    }

    /** Corresponds to Microsoft.Bot.Schema.ContactType */
    export enum ContactType {
        Unknown = 0, 
        Email = 1, 
        GroupMe = 2, 
        Kik = 3, 
        PhoneNumber = 4, 
        Skype = 5, 
        Slack = 6, 
        Telegram = 7, 
        Twitter = 8, 
        Web = 9, 
        API = 10, 
        Facebook = 11
    }

    /** Corresponds to Intercom.Models.ChannelStatusType */
    export enum ChannelStatusType {
        OK = 0, 
        Warning = 1, 
        Error = 2
    }



// WEBPACK FOOTER //
// ./../Intercom.ReactUI/Generated/ReactUI.ts